import PropTypes from "prop-types";
import styles from "./UpSellCarouselHeader.css";

const UpSellCarouselHeader = ({ title, subtitle, itemCount }) => (
  <div className={styles.header}>
    <div className={styles.title}>
      <span className={styles.titleLineOne}>{subtitle}</span>
      <span className={styles.titleLineTwo}>{title}</span>
    </div>
    <span className={styles.itemCounter}>{itemCount}</span>
  </div>
);

UpSellCarouselHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  itemCount: PropTypes.string.isRequired
};

export default UpSellCarouselHeader;
